import React from "react";
import "./Top_Filter_Div.css";
import Breadcrumb_comp from "../../common_components/breadcrumb-comp/Breadcrumb_comp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faSortDown,
  faTableCells,
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Tab } from "react-bootstrap";
import Sort_Offcanvas from "../sort_offcanvas/Sort_Offcanvas";
import Filter_Offcanvas from "../filter_offcanvas/Filter_Offcanvas";

const Top_Filter_Div = ({
  subTitle,
  selectedOption,
  setSelectedOption,
  activeSize,
  setActiveSize,
  setActiveHeight,
  activeHeight,
  activeMattress,
  setActiveMattress,
  discountMin,
  setDiscountMin,
  discountMax,
  setDiscountMax,
  breadcrumbs2,
  onFilterChange,
  setPriceRange,
  priceRange,
  setDiscount,
  discount,
  ...props
}) => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: props?.pageTitle, link: "", isActive: true },
  ];

  const [showSort, setShowSort] = React.useState(false);
  const [showFilter, setShowFilter] = React.useState(false);

  return (
    <div className="top_filter_div">
      <div className="container">
        <div className="two_divs">
          <div className="breadcrump_div">
            <Breadcrumb_comp
              breadcrumbs={breadcrumbs2 ? breadcrumbs2 : breadcrumbs}
            />
          </div>
          <div className="right_side_div">
            <div className="sort_div">
              <div
                className="inner_div"
                onClick={() => {
                  setShowFilter(true);
                }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/images/icons/filter.png"
                  }
                  className="sort_img"
                />
                <p className="sort_text">Filter</p>
                <FontAwesomeIcon icon={faSortDown} className="sort_icon" />
              </div>

              <div
                className="inner_div"
                onClick={() => {
                  setShowSort(true);
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/icons/sort.png"}
                  className="sort_img"
                />
                <p className="sort_text">Sort</p>
                <FontAwesomeIcon icon={faSortDown} className="sort_icon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Sort_Offcanvas
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        show={showSort}
        onHide={() => setShowSort(false)}
      />

      <Filter_Offcanvas
        setDiscount={setDiscount}
        discount={discount}
        priceRange={priceRange}
        setPriceRange={setPriceRange}
        setActiveMattress={setActiveMattress}
        activeMattress={activeMattress}
        activeSize={activeSize}
        setActiveSize={setActiveSize}
        setActiveHeight={setActiveHeight}
        activeHeight={activeHeight}
        discountMin={discountMin}
        setDiscountMin={setDiscountMin}
        discountMax={discountMax}
        setDiscountMax={setDiscountMax}
        onFilterChange={onFilterChange}
        show={showFilter}
        onHide={() => setShowFilter(false)}
      />
    </div>
  );
};

export default Top_Filter_Div;
